// extracted by mini-css-extract-plugin
export default {"EledoPropertyList":"EledoPropertyList_EledoPropertyList__OneNg","addRowButton":"EledoPropertyList_addRowButton__uJplr"};